import UiHelper from './UiHelper';

class HeaderSearch
{
    static init()
    {
        // dom references
        this.header = UiHelper.getNode('.js-site-header');
        this.showBtn = UiHelper.getNode('.js-trigger-header-search');
        this.form = UiHelper.getNode('.js-header-search');
        this.inputWrap = UiHelper.getNode('.js-header-search__input-wrap');
        this.submitBtn = UiHelper.getNode('.js-header-search__submit');
        this.hideBtn = UiHelper.getNode('.js-header-search__close');

        this.showBtn.addEventListener('click', e => this.showSearch());
        this.hideBtn.addEventListener('click', e => this.hideSearch());
    }

    static showSearch()
    {
        const inputWidth = this.calcInputWidth();
        this.form.classList.add('header-search--visible');
        this.inputWrap.style.width = `${inputWidth}px`;
        this.inputWrap.focus();
    }
    static hideSearch()
    {
        this.form.classList.add('header-search--hide');
        this.inputWrap.style.width = `0px`;
        setTimeout(() =>
        {
            this.form.classList.remove('header-search--visible');
            this.form.classList.remove('header-search--hide');
        }, 500);
    }

    static calcInputWidth()
    {
        let w;
        if (this.header.offsetWidth > 575)
        {
            w = UiHelper.getPrimaryNavWidth() - this.submitBtn.offsetWidth - this.hideBtn.offsetWidth + 12; // + 12 padding corrections
        }
        else
        {
            w = this.header.offsetWidth - this.submitBtn.offsetWidth - this.hideBtn.offsetWidth + 1; // full width
        }

        return w < 250 ? 250 : w; // 250 minimum
    }
}

export default HeaderSearch;
